import {createTheme} from '@material-ui/core/styles';

import {foundations} from '../../foundation';
import {MuiButton} from './components/MuiButton';
import {MuiChip} from './components/MuiChip';
import {MuiInputBase} from './components/MuiInputBase';
import {MuiInputLabel} from './components/MuiInputLabel';
import {palette} from './palette';

const {colors, spacing, fontWeights} = foundations;

export const LightTheme = createTheme({
  spacing,
  palette,
  typography: {
    fontFamily: 'Source Sans Pro',
    button: {
      fontFamily: 'Source Sans Pro',
      textTransform: 'none',
      letterSpacing: 'none',
    },
  },
  props: {
    MuiButtonBase: {
      disableRipple: true,
    },
    MuiButton: {
      disableElevation: true,
      disableRipple: true,
    },
    MuiTooltip: {
      arrow: true,
    },
    MuiButtonGroup: {
      disableElevation: true,
      disableRipple: true,
    },
    MuiInputLabel: {
      disableAnimation: true,
      shrink: false,
    },
    MuiOutlinedInput: {
      notched: false,
    },
    MuiFilledInput: {
      disableUnderline: true,
    },
    MuiPopover: {
      elevation: 3,
    },
    MuiSelect: {
      MenuProps: {
        getContentAnchorEl: null,
        anchorOrigin: {vertical: 'bottom', horizontal: 'left'},
      },
    },
    MuiIcon: {
      component: 'i',
    } as any,
  },
  overrides: {
    MuiTooltip: {
      tooltip: {fontSize: spacing(3)},
      arrow: {width: spacing(4)},
    },
    MuiIconButton: {
      root: {
        color: colors.gray[800],
        padding: spacing(2),
        borderRadius: spacing(1),
        '&:focus': {
          backgroundColor: colors.blackAlpha[50],
        },
        '&:disabled': {
          cursor: 'not-allowed',
          pointerEvents: 'auto',
        },
      },
      colorPrimary: {
        color: foundations.legacy.primary,
        '&:hover': {
          backgroundColor: 'rgba(46, 120, 199, 0.04)',
        },
        '&:focus': {
          backgroundColor: 'rgba(46, 120, 199, 0.04)',
        },
      },
    },
    ...({
      MuiAutocomplete: {
        option: {
          fontSize: '0.875rem',
        },
      },
    } as any),
    MuiButton,
    MuiChip,
    MuiFormLabel: {
      root: {
        fontWeight: fontWeights.semibold,
        letterSpacing: foundations.letterSpacings.normal,
        color: colors.gray[800],
        '&.Mui-focused': {
          color: colors.gray[800],
        },
      },
    },
    MuiInputLabel,
    MuiInputBase,
    MuiOutlinedInput: {
      input: {
        padding: spacing(3, 2),
      },
      inputMarginDense: {
        paddingTop: spacing(2),
        paddingBottom: spacing(2),
      },
      adornedStart: {
        paddingLeft: spacing(2),
      },
      adornedEnd: {
        paddingRight: spacing(2),
      },
      multiline: {
        padding: spacing(3, 2),
      },
    },
    MuiFilledInput: {
      root: {
        borderBottomLeftRadius: spacing(1),
        borderBottomRightRadius: spacing(1),
        backgroundColor: colors.blackAlpha[50],
        '&:hover': {
          backgroundColor: colors.blackAlpha[200],
        },
      },
      input: {
        padding: spacing(3, 2),
      },
      inputMarginDense: {
        paddingTop: '6px',
        paddingBottom: '6px',
      },
      adornedStart: {
        paddingLeft: '8px',
      },
      adornedEnd: {
        paddingRight: '8px',
      },
      multiline: {
        padding: '10px 8px',
      },
    },
    MuiInputAdornment: {
      positionStart: {
        marginRight: '4px',
      },
      positionEnd: {
        marginLeft: '0',
      },
    },
    MuiMenuItem: {
      root: {
        paddingTop: '0',
        paddingBottom: '0',
        lineHeight: spacing(10),
      },
      dense: {
        paddingTop: '0',
        paddingBottom: '0',
        lineHeight: spacing(8),
      },
    },
    MuiListSubheader: {
      root: {
        lineHeight: '2.5rem',
        fontSize: '0.8125rem',
      },
    },
    MuiListItemText: {
      root: {
        paddingRight: '8px',
      },
    },
    MuiListItemIcon: {
      root: {
        minWidth: spacing(10),
        color: 'inherit',
      },
    },
    MuiListItemSecondaryAction: {
      root: {
        right: spacing(2),
      },
    },
    MuiCheckbox: {
      root: {
        '&:hover': {
          backgroundColor: 'transparent',
        },
      },
    },
    MuiSwitch: {
      root: {
        padding: '7px',
      },
      thumb: {
        boxShadow:
          '0px 0px 1px -1px rgb(0 0 0 / 20%), 0px 0px 1px 0px rgb(0 0 0 / 20%), 0px 0px 3px 0px rgb(0 0 0 / 12%)',
      },
      switchBase: {
        '&:hover': {
          backgroundColor: 'transparent',
        },
      },
      track: {
        borderRadius: '25px',
      },
      sizeSmall: {
        padding: '2px',
      },
    },
  },
});
